import Icons from "@/assets";
import { Box, IconButton, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { getDisplayImage } from "@/utils/helper";
import { MediaSection, Place } from "@/types/common";
import BaseCard from "@/shared/components/BaseCard";
import PlaceThumbnail from "@/shared/components/PlaceThumbnail";
import { FONT_SIZES } from "@/shared/constants/typography";
import { storage, STORAGE_KEYS } from "@/utils/storage";

const DraftCard = ({ place, media, contributionId }: { place: Place; media: MediaSection[]; contributionId: string }) => {
  const navigate = useNavigate();

  return (
    <BaseCard
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        mt: "3.5%",
        minHeight: "20vw",
      }}
    >
      <Box sx={{ width: "15%" }}>
        <PlaceThumbnail
          src={getDisplayImage(media)}
          alt={place.name}
          size={{ xs: "11.65vw", sm: 48 }}
          borderRadius={2}
          sx={{ border: "none" }}
        />
      </Box>

      <Box sx={{ width: "70%" }}>
        <Typography
          sx={{
            fontSize: FONT_SIZES.BODY,
            fontWeight: 700,
            color: "#000000",
          }}
        >
          {place.name}
        </Typography>
        <Typography
          sx={{
            fontSize: FONT_SIZES.CAPTION,
            color: "#626262",
          }}
        >
          {place.address_text}
        </Typography>
      </Box>

      <Box sx={{ width: "10%", textAlign: "center" }}>
        <IconButton
          size="small"
          sx={{ padding: 0 }}
          onClick={() => {
            storage.setItem(STORAGE_KEYS.FROM_EXPLORE_TO_CONTRIBUTE, "true");
            navigate(`/contribution/update/${contributionId}`, {
              state: { ...place },
            });
          }}
        >
          <Box component={"img"} src={Icons.Edit} alt="Edit" />
        </IconButton>
      </Box>
    </BaseCard>
  );
};

export default DraftCard;
